import PubSub from 'pubsub-js';
import keyboard from 'keycode-ui';
import _ from 'lodash';

const deps = {};
/*---------------------------------------------------------*\
 * OtherRegionsController
\*---------------------------------------------------------*/
class PageLayoutController {
  //-----------------------------------
  // Constructor
  //-----------------------------------
  constructor($scope, $state, localService, storageKeys, states, topics, livefeedService, adProps, navigationService,
              $timeout, $document) {
    deps.$state = $state;
    deps.states = states;
    deps.topics = topics;
    deps.localService = localService;
    deps.storageKeys = storageKeys;
    deps.navigationService = navigationService;
    deps.$timeout = $timeout;
    deps.$document = $document[0];
    this.name = 'pageLayout';
    this.liveFeed = null;
    this.feedConfig = {
      story: {
        videoUrl: livefeedService.getLivefeed()
      }
    };
    this.adProps = adProps;

    const token1 = PubSub.subscribe(deps.topics.state.reactivate, () => {
      if (this.liveFeed) {
        this.liveFeed.initVideo();
        this.liveFeed.play();
      }
    });

    const token2 = PubSub.subscribe(deps.topics.state.inactivate, () => {
      if (this.liveFeed) {
        this.liveFeed.stop();
      }
    });

    const token3 = PubSub.subscribe(this.adProps.home.previousElement, (msg, data) => {
      this.adFocus = data.previousElement;
    });

    $scope.$on('$destroy', () => {
      PubSub.unsubscribe(token1);
      PubSub.unsubscribe(token2);
      PubSub.unsubscribe(token3);
    });
  }

  //-----------------------------------
  // Properties
  //-----------------------------------
  get region() {
    const _region = deps.localService.get(deps.storageKeys.selectedRegion);
    return _region ? _region.abbr : 'LI';
  }

  //-----------------------------------
  // Methods
  //-----------------------------------

  enlargeVideo() {
    deps.$state.go(deps.states.enlargedLiveFeed, { currentStory: this.feedConfig });
  }

  onLiveFeedReady(liveFeed) {
    this.liveFeed = liveFeed;
  }
  remoteKeyDownEnlargeBtn(event) {
    if (keyboard.isUp(event)) {
      event.preventDefault();
      deps.navigationService.focusEl('navbar', 'last');
    } else if (keyboard.isLeft(event)) {
      event.preventDefault();
      const pollCheck = !!deps.$document.querySelector('.poll-result');
      if (pollCheck) {
        deps.navigationService.focusEl('.main-menu-btn');
      } else {
        deps.navigationService.focusEl('.main-content', 1);
      }
    }
  }

  selectedLocation(event, location) {
    if (location === this.adProps.home.bottomBannerLocation) {
      if (keyboard.isUp(event)) {
        event.preventDefault();
        if (this.adFocus !== event.target && !_.isUndefined(this.adFocus)) {
          this.adFocus.focus();
        } else if (deps.$document.querySelector('.btngroup')) {
          deps.navigationService.focusEl('.btngroup', 'first');
        } else {
          const regionsCheck = deps.$document.querySelectorAll('other-regions button');
          deps.navigationService.focusEl('.main-content', !_.isUndefined(regionsCheck) ? regionsCheck.length : 1);
        }
      } else if (keyboard.isRight(event)) {
        this.adFocus = event.target;
      }
    } else if (location === this.adProps.home.rightBannerLocation) {
      if (keyboard.isLeft(event)) {
        event.preventDefault();
        if (deps.$document.querySelector('.btngroup')) {
          deps.navigationService.focusEl('.main-menu-btn');
        } else {
          deps.navigationService.focusEl('.footer_center');
        }
      }
    }
  }
}

PageLayoutController.$inject = [
  '$scope',
  '$state',
  'localService',
  'storageKeys',
  'states',
  'topics',
  'livefeedService',
  'adProps',
  'navigationService',
  '$timeout',
  '$document'
];

export default PageLayoutController;



/** WEBPACK FOOTER **
 ** ./client/app/components/common/pageLayout/pageLayout.controller.js
 **/